
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HolidaysList from './components/Holidays/HolidaysList';   //d
import CreateEmployee from './components/Employee/CreateEmployee';  //d
import EmployeeList from './components/Employee/EmployeeList';    //d
import EmployeeDetail from './components/Employee/EmployeeDetail';   //d
import ArchivedEmployeeList from './components/Employee/ArchivedEmployeeList';     //d
import HolidayForm from './components/Holidays/HolidayForm';  //d
import PrivateRoute from './components/common/PrivateRoute'; 
import Login from './components/Login/Login';    //d
import LandingPage from './components/LandingPage/LandingPage';      //d
import ApplyForLeave from './components/Leave/ApplyForLeave';         //d
import LeaveRequests from './components/Leave/LeaveRequests';     //d
import AttendancePortal from './components/Attendence/AttendancePortal';    //d
import SalarySlipForm from './components/SalarySlip/SalarySlipForm';         //d
import GetMyAttendance from './components/Attendence/GetMyAttendance';      //d
import AdminAttendanceLookup from './components/Attendence/AdminAttendanceLookup';   //d
import InventoryForm from './components/Inventory/InventoryForm';     //d
import InventoryList from './components/Inventory/InventoryList';      //d
import ReimbursementForm from './components/Reimbursment/ReimbursementForm';    //d
import ReimbursementList from './components/Reimbursment/ReimbursementList';   //d
import HolidaysListForEmployees from './components/Holidays/HolidaysListForEmployees';   //d
import MySalarySlip from './components/SalarySlip/MySalarySlip';       //d
import MyInventories from './components/Inventory/MyInventories';      //d
import UserProfile from './components/Employee/UserProfile';         //d
import AssignInventoryToEmployee from "./components/Inventory/AssignInventoryToEmployee";     //d
import InventorySearch from './components/Inventory/InventoryDetail';      //d
import EmployeeDashboard from './components/Dashboard/Dashboard';         //d
import NotificationForm from './components/Notification/NotificationForm';   //d
import ManagerList from './components/ManagerList/ManagerList';            //d
import ManagerFeedbackForm from './components/Performance/ManagerFeedbackForm';
import SelfAssessmentForm from './components/Performance/SelfAssessmentForm';
import MyReimbursements from './components/Reimbursment/MyReimbursements';     //d
import ManagerleaveRequest from './components/Leave/ManagerLeaveRequests';    //d
import contactdetail from './components/Employee/contactdetail';   //d
import CalendarView from './components/Calender/CalendarView';       //d
import SendMessage from './components/Messages/SendMessage';   //d
import MyMessages from './components/Messages/MyMessages';    //d
import MySentMessages from './components/Messages/MySentMessages';  //d
import Whiteboard from './components/Whiteboard/Whiteboard';  //d
import chatboard from './components/Chatboard/ChatBoard';
import groupchatboard from './components/Chatboard/Groupchat';
import timesheet from "./components/Timesheet/TimesheetForm";      //d
import timesheetlist from "./components/Timesheet/TimesheetList";    //d
import timesheetacess from "./components/Timesheet/TimesheetAccess";   //d
import ExpenseDashboard from "./components/Reimbursment/ExpenseDashboard"; //d
import ResetPassword from "./components/Reset_Password/ResetPassword";
import ForgotPassword  from "./components/ForgotPassword/ForgotPassword";
import ReimbursementReport from "./components/Reimbursment/ReimbursementReport"
import VideoUpload from "./components/VideoUpload/VideoUpload";
import OvertimeRequest from "./components/Overtime/OvertimeRequest";
import ManagerOvertimeRequests from "./components/Overtime/ManagerOvertimeRequests";
import ManagerAttendanceApprovals from "./components/Attendence/ManagerAttendanceApprovals";
import AttendanceRegularization from "./components/Attendence/AttendanceRegularization";
import AppUpdateAdmin from "./components/AppUpdate/AppUpdateAdmin";
import AppUpdateDownload from "./components/AppUpdate/AppUpdateDownload";

function App() {
  return (
    <Router>
      <div className="App">
        <main className="App-main">
          <Routes>
            <Route path="/" element={<LandingPage/>} />


            <Route path="/holidays" element={<PrivateRoute element={HolidaysList} />} />
            <Route path="/create-employee" element={<PrivateRoute element={CreateEmployee} />} />
            <Route path="/EmployeeList" element={<PrivateRoute element={EmployeeList} />} />
            <Route path="/EmployeeDetail" element={<PrivateRoute element={EmployeeDetail} />} />
            <Route path="/ArchivedEmployeeList" element={<PrivateRoute element={ArchivedEmployeeList} />} />
            <Route path="/HolidayForm" element={<PrivateRoute element={HolidayForm} />} />
            <Route path="/ApplyForLeave" element={<PrivateRoute element={ApplyForLeave} />} />
            <Route path="/LeaveRequests" element={<PrivateRoute element={LeaveRequests} />} />
            <Route path="/AttendancePortal" element={<PrivateRoute element={AttendancePortal} />} />
            <Route path="/SalarySlipForm" element={<PrivateRoute element={SalarySlipForm} />} />
            <Route path="/GetMyAttendance" element={<PrivateRoute element={GetMyAttendance} />} />
            <Route path="/AdminAttendanceLookup" element={<PrivateRoute element={AdminAttendanceLookup} />} />
            <Route path="/InventoryForm" element={<PrivateRoute element={InventoryForm} />} />
            <Route path="/InventoryList" element={<PrivateRoute element={InventoryList} />} />
            <Route path="/ReimbursementForm" element={<PrivateRoute element={ReimbursementForm} />} />
            <Route path="/ReimbursementList" element={<PrivateRoute element={ReimbursementList} />} />
            <Route path="/HolidaysListForEmployees" element={<PrivateRoute element={HolidaysListForEmployees} />} />
            <Route path="/MySalarySlip" element={<PrivateRoute element={MySalarySlip} />} />
            <Route path="/MyInventories" element={<PrivateRoute element={MyInventories} />} />
            <Route path="/UserProfile" element={<PrivateRoute element={UserProfile} />} />
            <Route path="/AssignInventoryToEmployee" element={<PrivateRoute element={AssignInventoryToEmployee} />} />
            <Route path="/InventorySearch" element={<PrivateRoute element={InventorySearch} />} />
            <Route path="/EmployeeDashboard" element={<PrivateRoute element={EmployeeDashboard} />} />
            <Route path="/NotificationForm" element={<PrivateRoute element={NotificationForm} />} />
            <Route path="/ListByRole" element={<PrivateRoute element={ManagerList} />} />
            <Route path="/ManagerFeedbackForm" element={<PrivateRoute element={ManagerFeedbackForm} />} />
            <Route path="/SelfAssessmentForm" element={<PrivateRoute element={SelfAssessmentForm} />} />
            <Route path="/MyReimbursements" element={<PrivateRoute element={MyReimbursements} />} />
            <Route path="/ManagerleaveRequest" element={<PrivateRoute element={ManagerleaveRequest} />} />
            <Route path="/contactdetail" element={<PrivateRoute element={contactdetail} />} />
            <Route path="/CalendarView" element={<PrivateRoute element={CalendarView} />} />
            <Route path="/SendMessage" element={<PrivateRoute element={SendMessage} />} />
            <Route path="/MyMessages" element={<PrivateRoute element={MyMessages} />} />
            <Route path="/MySentMessages" element={<PrivateRoute element={MySentMessages} />} />
            <Route path="/Whiteboard" element={<PrivateRoute element={Whiteboard} />} />
            <Route path="/chatboard" element={<PrivateRoute element={chatboard} />} />
            <Route path="/groupchatboard" element={<PrivateRoute element={groupchatboard} />} />
            <Route path="/timesheet" element={<PrivateRoute element={timesheet} />} />
            <Route path="/timesheetlist" element={<PrivateRoute element={timesheetlist} />} />
            <Route path="/timesheetacess" element={<PrivateRoute element={timesheetacess} />} />
            <Route path="/ExpenseDashboard" element={<PrivateRoute element={ExpenseDashboard} />} />
            <Route path="/ResetPassword" element={<PrivateRoute element={ResetPassword} />} />
            <Route path="/ReimbursementReport" element={<PrivateRoute element={ReimbursementReport} />} />
            <Route path="/VideoUpload" element={<PrivateRoute element={VideoUpload} />} />
            <Route path="/OvertimeRequest" element={<PrivateRoute element={OvertimeRequest} />} />
            <Route path="/ManagerOvertimeRequests" element={<PrivateRoute element={ManagerOvertimeRequests} />} />
            <Route path="/ManagerAttendanceApprovals" element={<PrivateRoute element={ManagerAttendanceApprovals} />} />
            <Route path="/AttendanceRegularization" element={<PrivateRoute element={AttendanceRegularization} />} />
            <Route path="/app-update-admin" element={<PrivateRoute element={AppUpdateAdmin} />} />
            <Route path="/app-update-download" element={<PrivateRoute element={AppUpdateDownload} />} />



            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />


          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
